import { Fragment, h } from "preact";
import { useState, useContext } from "preact/hooks";
import { makeStyles } from "@mui/styles";
import {
	Box,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	MenuItem,
	Paper,

	Stack,
	TextField,
	ToggleButtonGroup,
	ToggleButton,
	Typography,
} from "@mui/material";

import { AppContext } from "../../AppContext";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		width: "25ch",
	},
	formControl: {
		margin: theme.spacing(1),
		marginLeft: 0,
		minWidth: 120,
		width: "100%",
	},
}));

export default function SellerDetails({ state, handleChange, handleChangeCheckbox, du_uid }) {
	const app = useContext(AppContext);

	const classes = useStyles();
	return (
		<div>
			<Grid container spacing={2} alignItems="center">
				<Grid item xs={12}>
					<Typography variant="h5">Propriété du bien</Typography>
					{state.is_owner !== null && <FormControlLabel
						control={
							<Checkbox checked={state.is_owner} onChange={handleChangeCheckbox} name="is_owner" color="primary" disabled={state.ro} />
						}
						label="Je suis propriétaire du bien"
					/>}
					{state.is_owner === null && <Stack spacing={1}>
						<Typography>Etes-vous propriétaire du bien ?</Typography>
						<Box display={"flex"} justifyContent="flex-start">
							<Box p={1}><Button variant="outlined" onClick={() => handleChange({ target: { name: "is_owner", value: false } })}>NON</Button></Box>
							<Box p={1}><Button variant="outlined" onClick={() => handleChange({ target: { name: "is_owner", value: true } })}>OUI</Button></Box>
						</Box>
					</Stack>

					}
				</Grid>
				{state.is_owner && (
					<Grid item xs={12}>
						<Stack spacing={1}>
							<TextField
								id="marital_status_id"
								name="marital_status_id"
								select
								label=""
								value={state.marital_status_id ? state.marital_status_id : "0"}
								onChange={handleChange}
								helperText=""
								variant="outlined"
								size="small"
								style={`margin-right: 10px; ${state.marital_status_id == "0" ? " background-color: #ffdad7;" : ""}`}
								disabled={state.ro}

							>
								<MenuItem key={0} value={"0"}>
									<em>Choisir</em>
								</MenuItem>
								{state.marital_statuses.map((option) => (
									<MenuItem key={option.id} value={option.id}>
										{option.d}
									</MenuItem>
								))}
							</TextField>
							{state.marital_status_id == "2" && (
								<Stack spacing={2} justifyContent={"flex-start"} alignItems={"flex-start"}>
									<Typography variant="h5">Dans ce cas, mon conjoint est-il concerné par la transaction ?</Typography>
									<ToggleButtonGroup
										color="primary"
										value={state.union}
										exclusive
										onChange={handleChange}
									//size="large"
									>
										<ToggleButton value="O" name="union">Oui</ToggleButton>
										<ToggleButton value="N" name="union">Non</ToggleButton>

									</ToggleButtonGroup>
								</Stack>)}

						</Stack>
					</Grid>
				)}{" "}
				{state.is_owner && state.union === "O" && (
					<Fragment>
						<Grid item xs={12} md={6}>
							{state.siblings.length > 0 && (
								<FormControl variant="outlined" className={classes.formControl}>
									<TextField
										name="has_union_with_id"
										select
										label=""
										value={state.has_union_with_id ? state.has_union_with_id : "0"}
										onChange={handleChange}
										helperText=""
										variant="outlined"
										size="small"
										style="margin-right: 10px;"
									>
										<MenuItem key={0} value={"0"}>
											<em>Le conjoint n'est pas encore dans la liste</em>
										</MenuItem>
										{state.siblings.map((s) => {
											return (
												<MenuItem key={0} value={s.uid}>
													<Typography variant="body1">{s.nm}</Typography>
												</MenuItem>
											);
										})}
									</TextField>

								</FormControl>
							)}
							{state.siblings.length == 0 && <Typography variant="body1">Il n'y a pas d'autre propriétaire pour ce bien</Typography>}
						</Grid>

						{(!state.has_union_with_id || state.has_union_with_id === "0") && <Grid item xs={12} >
							{state.marital_status_id == "2" && state.union === "O" && (//state.siblings.length == 0 && (
								<div>
									<Typography variant="body1">Votre conjoint n'est pas défini</Typography>
									<Button variant="outlined" onClick={() => app.refPopUp.current.handleChangeState(
										{
											opened: true,
											type: "024",
											params: {
												uid: du_uid
											}
										}
									)}>
										Inviter mon/ma conjoint(e)
									</Button>
								</div>
							)}
						</Grid>}
					</Fragment>
				)}
				{state.proxied.length > 0 && <Grid item xs={12}>
					<Typography variant="h5">Représentation de personnes</Typography>
					{/* {state.proxied.length == 0 && <Typography variant="body1">Vous ne représentez aucun propriétaire du dossier</Typography>} */}
					{state.proxied.length > 0 && <Typography variant="body1">Vous représentez:</Typography>}
					{state.proxied.map((prxd) => {
						return (
							<Paper style="padding: 10px; margin-top: 10px; max-width: 500px;">
								<Typography variant="body1">{prxd.n}</Typography>
							</Paper>
						);
					})}
				</Grid>}
				{/* <Grid item xs={12}>
					<Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start">
						<Box>
							<Typography variant="h5">Mon notaire</Typography>
						</Box>
						<Box>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_fname"
									name="notary_fname"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Prénom"
									fullWidth
									margin="dense"
									value={state.notary_fname}
									onChange={handleChange}
								/>
							</FormControl>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_lname"
									name="notary_lname"
									variant="outlined"
									style={{
										marginLeft: 10,
										marginRight: 10,
									}}
									placeholder="Nom"
									fullWidth
									margin="dense"
									value={state.notary_lname}
									onChange={handleChange}
								/>
							</FormControl>
						</Box>
						<Box>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_email"
									name="notary_email"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Email *"
									fullWidth
									margin="dense"
									value={state.notary_email}
									onChange={handleChange}
								/>
							</FormControl>
						</Box>
						<Box>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_siret"
									name="notary_siret"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
										width: "100%",
									}}
									placeholder="SIRET"
									fullWidth
									margin="dense"
									value={state.notary_siret}
									onChange={handleChange}
								/>
							</FormControl>
						</Box>
						<Box>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_adr1"
									name="notary_adr1"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Adresse"
									fullWidth
									margin="dense"
									value={state.notary_adr1}
									onChange={handleChange}
								/>
							</FormControl>
						</Box>
						<Box>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_cp"
									name="notary_cp"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Code postal"
									fullWidth
									margin="dense"
									value={state.notary_cp}
									onChange={handleChange}
								/>
							</FormControl>
							<FormControl variant="outlined" hiddenLabel>
								<TextField
									id="notary_ville"
									name="notary_ville"
									variant="outlined"
									style={{
										marginLeft: 10,
										marginRight: 10,
									}}
									placeholder="Ville"
									fullWidth
									margin="dense"
									value={state.notary_ville}
									onChange={handleChange}
								/>
							</FormControl>
						</Box>
					</Box>
				</Grid> */}
			</Grid>
		</div >
	);
}
